import { customInspectionTypeSettings } from '../../../../common/src/domain/customInspectionTypes/customInspectionTypeSettings';
import { customInspectionTypeFrontEndSettings } from '../../customInspectionTypes/customInspectionTypeFrontEndSettings';

export function getConditionLabelForMap(lastSurveyCondition: string | undefined, inspectionStandardType: string | undefined) {
    if (!inspectionStandardType) {
        return undefined;
    }

    const commonSettings = customInspectionTypeSettings[inspectionStandardType];
    if (commonSettings && commonSettings.conditionScoreToText) {
        const colorCode = commonSettings.conditionScoreToColorCode(lastSurveyCondition);

        return {
            text: '', // There is only space for one character.
            backgroundColor: colorCode,
        };
    }

    const settings = customInspectionTypeFrontEndSettings[inspectionStandardType];

    if (settings?.showLabelInSurveysMap && lastSurveyCondition && commonSettings && commonSettings.conditionScoreToScore) {
        return {
            text: commonSettings.conditionScoreToScore(lastSurveyCondition),
            backgroundColor: commonSettings.conditionScoreToColorCode(lastSurveyCondition),
        };
    }
    return undefined;
}
